<!--
  员工P标签
-->
<template>
  <p slot="reference" class="iconP">
    {{ text }}
    <i
      v-show="text != '-'"
      @click="copy(text)"
      class="el-icon-document-copy pointer icon green-Cd0100"
    ></i>
  </p>
</template>

<script>
import AES from "@/mixins/AES";
import { eventBus } from "@/plugins/eventBus";
export default {
  data() {
    return {
      text: "-",
      data: [],
      value: "",
    };
  },
  props: {
    id: {
      default() {
        return "";
      },
    },
  },
  methods: {
    getData(count = 0) {
      if (window.localStorage.getItem("staff")) {
        //先查询是否存在员工数据
        this.data = JSON.parse(
          AES.decrypt(window.localStorage.getItem("staff"))
        );
        let text = this.data.filter((item) => item.userId == this.id);
        if (text.length === 0) {
          //没匹配到对应值
          this.text = this.id || "-";
        } else {
          this.text = text[0].userName;
        }
      } else {
        setTimeout(() => {
          this.getData(count + 1);
        }, 200);
        if (count == 17) {
          this.$api.post("/api/SysUser/GetSysUserDropList").then((res) => {
            window.localStorage.setItem(
              "staff",
              AES.encrypt(JSON.stringify(res.data))
            );
            this.getData();
          });
        }
      }
    },
  },
  mounted() {
    eventBus.$emit("getStaff");
    eventBus.$off("getStaff");
    this.getData();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.getData();
      },
      immediate: true,
    },
    id(newValue) {
      this.value = newValue;
      this.getData();
    },
  },
};
</script>

<style></style>
